import clsx from "clsx";
import React from "react";

import { ChevronDown } from "lucide-react";

import styles from "./index.module.css";

export interface ButtonDropdownProps extends React.ComponentProps<"button"> {
  /** Children elements */
  children: React.ReactNode;
  /** Size */
  size?: "base" | "sm";
  /** Disabled state */
  isDisabled?: boolean;
  /** Indicates if the dropdown is expanded */
  "aria-expanded"?: boolean;
  /** ID of the dropdown menu this button controls */
  "aria-controls"?: string;
  /** Indicates what kind of popup the button triggers */
  "aria-haspopup"?:
    | boolean
    | "true"
    | "false"
    | "menu"
    | "listbox"
    | "tree"
    | "grid"
    | "dialog";
}

const ButtonDropdown = React.forwardRef<HTMLButtonElement, ButtonDropdownProps>(
  (
    {
      size = "base",
      children,
      isDisabled = false,
      className,
      "aria-expanded": ariaExpanded,
      "aria-controls": ariaControls,
      "aria-haspopup": ariaHaspopup = "true",
      ...rest
    },
    ref
  ) => {
    const classes = clsx(
      styles.root,
      styles[size],
      {
        [styles.isDisabled]: isDisabled,
      },
      className
    );

    return (
      <button
        className={classes}
        disabled={isDisabled}
        ref={ref}
        aria-expanded={ariaExpanded}
        aria-controls={ariaControls}
        aria-haspopup={ariaHaspopup}
        {...rest}
      >
        {children}
        <ChevronDown size={16} aria-hidden="true" />
      </button>
    );
  }
);

ButtonDropdown.displayName = "ButtonDropdown";
export default ButtonDropdown;
